import { css } from '@emotion/react';

import { Link, Typography } from '@zapier/design-system';
import { isInIframe, urls, useSize } from '@zapier/identity-utils';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';
import { usePreviousUrl } from '@zapier/auth-pages/src/utils';
import { useRouter } from 'next/router';

const textStyle = css`
  ${Typography.paragraph1}
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

function getPreviousUrl(currentUrl: string, previousUrl: string | undefined) {
  if (previousUrl && previousUrl !== currentUrl) {
    return previousUrl;
  }
  return urls.LOGIN_URL;
}

export function CookiesDisabledPage() {
  const size = useSize();
  const router = useRouter();
  // Fall back to login url if we don't have a previous url
  const previousUrl = getPreviousUrl(router.asPath, usePreviousUrl());

  function goBack() {
    router.back();
  }

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={'Please enable cookies'}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={textStyle}>
          To use Zapier, you need to enable cookies, including third-party
          cookies. Please refer to your browser’s help docs for instructions on
          how to enable them.
        </p>
        <p css={textStyle}>
          If cookies are enabled, you should{' '}
          <Link onClick={goBack} role="link">
            go back
          </Link>{' '}
          and try again.
        </p>
        {isInIframe() && (
          <p css={textStyle}>
            You can also{' '}
            <Link href={previousUrl} target="_blank" role="link">
              click here
            </Link>{' '}
            to try in a new tab.
          </p>
        )}
      </section>
    </AuthLayout>
  );
}
